import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
const CreateFlowModal = ({ isOpen, onClose, addFlow }) => {
  const [flowName, setFlowName] = useState("");
  const [selectedFlow, setSelectedFlow] = useState("");
  const handleCreateFlow = () => {
    if (!flowName || !selectedFlow) {
      alert("Please fill in all fields.");
      return;
    }
    const newFlow = {
      id: Date.now(),
      name: flowName,
      type: selectedFlow.toLowerCase(),
      status: false,
      default: false,
      keywords: "",
      explanation: "",
    };
    addFlow(newFlow);
    onClose();
    setFlowName("");
    setSelectedFlow("");
  };
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontWeight: 700,
          color: "#1F2937",
          fontFamily: "Montserrat",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Create Flow
        <IconButton onClick={onClose}>
          <AiOutlineClose />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: "#F9FAFB" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <TextField
            label="Flow Name"
            fullWidth
            value={flowName}
            onChange={(e) => setFlowName(e.target.value)}
            size="small"
          />
          <TextField
            select
            label="Flow Type"
            fullWidth
            value={selectedFlow}
            onChange={(e) => setSelectedFlow(e.target.value)}
            size="small"
          >
            <MenuItem value="Whatsapp Flow">Whatsapp Flow</MenuItem>
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#25D366",
            textTransform: "none",
            "&:hover": { bgcolor: "#22C35E" },
          }}
          onClick={handleCreateFlow}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CreateFlowModal;